import { Box, Grid, Stack, Typography } from 'src/components/mui';
//@ts-ignore
import React from 'react';

type Props = {
  translation?: any;
};

export default function Navigation({ translation: t }: Props) {
  return (
    <Grid container spacing={10} justifyContent="center" columns={9}>
      <Grid size={3}>
        <Stack spacing={10} textAlign="center">
          <Typography>{t?.helpMouseDrag || 'Click and Drag to look around the Space'}</Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_mouse_drag_left.png" alt="" sx={{ width: 95, height: '215px', objectFit: 'contain' }} />
          </Stack>
          <Typography>
            {t?.helpMouseDragOr || 'Use the arrow keys to turn left and right'}
          </Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_keyboard_left_right.png" alt="" sx={{ width: { xs: 60, sm: 80, md: 100 }, height: { xs: 60, sm: 80, md: 100 }, objectFit: 'contain' }} />
          </Stack>
        </Stack>
      </Grid>
      <Grid size={3}>
        <Stack spacing={10} textAlign="center">
          <Typography>
            {t?.helpMouseAround || 'Click on the rings throughout the space to move around'}
          </Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_mouse_click.png" alt="" sx={{ width: 95, height: '215px', objectFit: 'contain' }} />
          </Stack>
          <Typography>
            {t?.helpMouseAroundOr || 'Use the arrow keys to move forward and back'}
          </Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_keyboard_up_down.png" alt="" sx={{ width: { xs: 60, sm: 80, md: 100 }, height: { xs: 60, sm: 80, md: 100 }, objectFit: 'contain' }} />
          </Stack>
        </Stack>
      </Grid>
      <Grid size={3}>
        <Stack spacing={10} textAlign="center">
          <Typography>{t?.helpMouseWheel || 'Use the scroll wheel to zoom in and out'}</Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_mouse_zoom.png" alt="" sx={{ width: 95, height: '215px', objectFit: 'contain' }} />
          </Stack>
          <Typography>
            {t?.helpMouseWheelOr || 'Use the plus and minus keys to zoom in and out'}
          </Typography>
          <Stack spacing={2} alignItems="center">
            <Box component="img" src="https://static.treedis.com/nav-images/nav_help_zoom_keys.png" alt="" sx={{ width: { xs: 60, sm: 80, md: 100 }, height: { xs: 60, sm: 80, md: 100 }, objectFit: 'contain' }} />
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
}
